import { createFileRoute } from "@tanstack/react-router";
import { PublicBuchen } from "@/pages/PublicBuchen";

/**
 * Bewusst **außerhalb** von `_angemeldet` — wie `/angebot/$token`: Der
 * öffentliche Buchungslink (13.09.2026) ist der Calendly-Ersatz für Website
 * und Signatur. Der Slug des Gastgebers ist der Zugang; die Datengrenze
 * (nur Tage, Slots, eigene Bestätigung) hält das Backend.
 */
export const Route = createFileRoute("/buchen/$slug")({
	component: BuchenSeite,
});

function BuchenSeite() {
	const { slug } = Route.useParams();
	return <PublicBuchen slug={slug} />;
}
